import { render, staticRenderFns } from "./ExistingSimilars.vue?vue&type=template&id=3891af6b&scoped=true&"
import script from "./ExistingSimilars.vue?vue&type=script&lang=js&"
export * from "./ExistingSimilars.vue?vue&type=script&lang=js&"
import style0 from "./ExistingSimilars.vue?vue&type=style&index=0&id=3891af6b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3891af6b",
  null
  
)

export default component.exports